module.exports = __webpack_public_path__ + "static/img/under-maintenance.5bd1b90.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/under-maintenance.svg
// module id = Eaml
// module chunks = 201